import { DesignSystem } from "../design-system.js";
import { SvgIcon } from "./svg-icon.js";
import { styles } from "./svg-icon.styles.js";
import { template } from "./svg-icon.template.js";
/**
 * Compose the SvgIcon component definition.
 *
 * @public
 * @remarks
 * HTML Element: <fabric-svg-icon>
 */
export const definition = SvgIcon.compose({
    name: `${DesignSystem.prefix}-svg-icon`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
definition.define(DesignSystem.registry);
//# sourceMappingURL=svg-icon.definition.js.map